const shopNewestListings = {
  displayField: 'header',
  name: 'Shops Newest Listings',
  description: 'Contentful new schema template',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'shopId',
      name: 'Shop ID',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'shopNewestListings',
    version: 16,
    updatedAt: '2023-08-03T14:34:20.007Z'
  }
};
export default shopNewestListings;